import { schema } from 'normalizr'

export const workerSchema = new schema.Entity('workers')
